import React from 'react'

import { Button, ButtonBase, Container } from '@mui/material';
import roxarImage from '../assets/Home_screen/home_roxar_image.png'
import adaptabiltyIcon from '../assets/Home_screen/home_icon_adaptability.png'
import expertiseIcon from '../assets/Home_screen/home_icon_expertise.png'
import costIcon from '../assets/Home_screen/home_icon_cost.png'
import dataIcon from '../assets/Home_screen/home_icon_data_quality.png'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

 

const Home = ()=>{
  return(
    <div maxWidth='md' className='home_content'>
        <div className='main_menu' >
          <div className='learn_more_column'>
            <p>What value can a Roxar 2600 Multiphase Flow Meter (MPFM) drive to my upstream production operations?</p>
            <Button className='forward_button learn_more_button' component={Link} to={'/adaptability'}>Learn More &nbsp;  <ArrowForwardIosIcon/> </Button>
          </div>
          <div className='image_column'>
            <img src={roxarImage} />
          </div>
          <div className='nav_column'>
            <p>Click one of the sections below to start exploring areas to improve your options.</p>
            <div className='nav_container'>
              <ButtonBase className='main_nav' component={Link} to={'/adaptability'}>
                <div className='nav_icon_container'>
                  <img src = {adaptabiltyIcon}/>
                  </div>
                <p>Adaptabilty &<br /> Scalabilty</p>
              </ButtonBase>
              <ButtonBase className='main_nav' component={Link} to={'/data'}>
                <div className='nav_icon_container'>
                  <img src = {dataIcon}/>
                  </div>
                <p>Data Quality &<br /> Production Insight</p>
              </ButtonBase>
            </div>
            <div className='nav_container'>
              <ButtonBase className='main_nav' component={Link} to={'/expertise'}>
                <div className='nav_icon_container'>
                  <img src = {expertiseIcon}/>
                  </div>
                <p>Expertise Availabilty</p>
              </ButtonBase>
              <ButtonBase className='main_nav' component={Link} to={'/cost'}>
                <div className='nav_icon_container'>
                <img src = {costIcon}/>
                </div>
                <p>Cost Savings</p>
              </ButtonBase>
            </div>
          </div>

        </div>
      </div>
      )
    }

    export default Home